<template>
	<div>
		<buttonlist @help="help" @search="search" @reflash="reflash" @exps="exps" ref="SetBtn"></buttonlist>
			<ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
			<li style="width: 100%; margin-top:0px" id="xpane-0">
				<vxe-table
						:data="dataSet"
						:highlight-current-row="true"
						resizable
						show-overflow="tooltip"
						:height="tableHeight"
						:loading="loading"
						header-row-class-name="headerclass"
						size="mini"
						border
						ref="singleTable1"
				>
					<vxe-table-column field="partcode" :title="$t('getapi[112]')" width="120"></vxe-table-column>
					<vxe-table-column field="partversion" :title="$t('getapi[149]')" width="120"></vxe-table-column>
					<vxe-table-column field="mp_flag" :title="$t('getapi[134]')" width="120"></vxe-table-column>
					<vxe-table-column field="part_master_unit" :title="$t('getapi[128]')" width="120"></vxe-table-column>
					<vxe-table-column field="item_code" :title="$t('getapi[876]')" width="120"></vxe-table-column>
					<vxe-table-column field="remain" :title="$t('getapi[7194]')" width="120" align="right"></vxe-table-column>
				</vxe-table>
			</li>
		</ul>

		<serce :isVisible="isVisible" queryData="SupplyDemandRemain" ref="ser" @getser="serclick"></serce>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'2_supplydemandremain',
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight3,
                maxHeight: this.$windowSize.tableHeight3,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: this.$http.getPageSize('2_supplydemandremain'), // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			tableHeader: [],
            scrollTop:0,
		};
	},
    watch: {
        dataSet: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
	mounted: function() {
		let that = this;
		that.userData = sessionStorage.getItem('userData');
		that.authority();
		that.colsort();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
		colsort(){
			let that = this;
			that.$loadviewfields.Fileds('supplydemandremain',0,PFileds=>{
			that.tableHeader=PFileds;		
		});	
		},
		sortclick(val){
			if(val==1){
				this.colsort();
			}
		},
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6600]"),'MRP');
        },
		//type 1 一览权限 、2 编辑界面权限
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
		},
		handleSizeChange(val) {
			this.pageSize = val;
            this.$http.savePageSize('2_supplydemandremain',val)
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
        // 查询
        search() {
            let that = this;
            that.isVisible = true;
            that.$refs.ser.clearInput(that.isVisible, 'SupplyDemandRemain');
        },
        //获取查询条件
        serclick(val) {
            this.queryData = val;
            this.confirmGetView();
        },
        // 确认获取数据
        confirmGetView() {
            let that = this;
            that.pageIndex = 1
            that.isVisible = false;
            that.getView();
        },
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
            let datac = [];
            for (let i = 0; i < that.queryData.length; i++) {
                datac.push({
                    query_Condition: that.queryData[i].query_Condition,
                    query_field_type: that.queryData[i].Query_Field_Type,
                    query_field_name: that.queryData[i].Query_Field_Name,
                    query_sort: that.queryData[i].query_sort,
                    row_sign: that.queryData[i].row_sign
                });
            }
            let parm = {
                PageIndex: that.pageIndex,
                PageSize: that.pageSize,
                SelectIndex: that.SelectIndexs,
                Param: datac
            };
			that.$http.urlpost('/MRP/CountView/GetSupplyDemandInfoRemain', parm, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.loading = false;
				} else {
					that.$message.error(res.Msg);
				}
				that.authority();
			});
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		// 导出
		exps() {
		    let that = this
            let datac = [];
            for (let i = 0; i < that.queryData.length; i++) {
                datac.push({
                    query_Condition: that.queryData[i].query_Condition,
                    query_field_type: that.queryData[i].Query_Field_Type,
                    query_field_name: that.queryData[i].Query_Field_Name,
                    query_sort: that.queryData[i].query_sort,
                    row_sign: that.queryData[i].row_sign
                });
            }
            let parm = {
                PageIndex: that.pageIndex,
                PageSize: that.pageSize,
                SelectIndex: that.SelectIndexs,
                Param: datac
            };
            that.$refs.SetBtn.SetOneBtnEnable('export', false);
            that.$http.urlpost('/MRP/CountView/SupplyDemandRemainToExcel', parm, function (res) {
                if (res.Success == 1) {
                    let hrefurl = Common.Url + res.DataContent.URL;
                    window.open(hrefurl);
                }
                that.$refs.SetBtn.SetOneBtnEnable('export', true);
            });
		},
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
</style>
